"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiDef_AppConfig = void 0;
const types_1 = require("../types");
exports.ApiDef_AppConfig = {
    vv1: {
        getConfigByKey: { method: types_1.HttpMethod.GET, path: 'v1/app-config/get-resolver-data-by-key' },
    }
};
